import React from 'react'
import { Redirect } from 'react-router-dom'
import { useQueryParam } from '../../shared/hooks/location'
import { AuthHead, AuthMark, AuthPage } from '../../shared/sso-workspace/auth-card'
import { errorCopy } from './error-copy'

// Packages built before Phase F open /lms/launch?lt=<launch> (the app bridge)
// and /link?lt=<launch> (the sign-in page) on the admin; the launch window is
// /lms/launch/<intent> now (F-12). Both old addresses replace themselves with
// the window's, so Back does not return to them. A launch from before F is
// named by its 32-hex row id and the LMS answers it as expired; the window
// says so.
//
// The name goes into a path, so only a launch's own alphabet (letters,
// digits, - and _) is ever put there: anything else is "launch not found",
// never an address.
const LAUNCH_NAME = /^[A-Za-z0-9_-]{1,128}$/

export const LegacyLaunchRedirect = () => {
  const lt = useQueryParam('lt')

  if (lt && LAUNCH_NAME.test(lt)) {
    return <Redirect to={`/lms/launch/${lt}`} />
  }

  const copy = errorCopy('LAUNCH_TOKEN_NOT_FOUND')
  return (
    <AuthPage labelledBy="launch-title">
      <AuthHead id="launch-title" title={copy.title} lede={copy.explanation} mark={<AuthMark tone="bad">!</AuthMark>} />
      <p className="m-0">{copy.action}</p>
    </AuthPage>
  )
}
